var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTableRow',{staticClass:"v-table-ks6-actions",attrs:{"on-left":true,"template":"1fr","head":""},scopedSlots:_vm._u([{key:"leftHeader",fn:function(){return _vm._l((_vm.filteredActions),function(action,index){return _c('VTableCell',{key:index},[_c('VNodeFunctional',{attrs:{"vnode":action}})],1)})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }